// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__TgW8_","product_card_wrapper":"Products_product_card_wrapper__KkX9p","preloader_wrapper":"Products_preloader_wrapper__2D3Vr"};